import { useFormContext, useWatch } from 'react-hook-form';
import type { IGetDeliverablesServiceRes } from '@/api/Sherpa/Project/modules/ProjectTdm/types';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { useDeliverables } from '@/hooks/ReactQueryHooks/useDeliverablesQuery';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import { capitalize, formatDate3 } from '@/utils';
import type { DeliverableChangeOrderSchema } from '../DeliverableForm/validationSchema';

export function DeliverableSelect({ projectId, isDisabled }: { projectId: string; isDisabled?: boolean }) {
  const formMethods = useFormContext<DeliverableChangeOrderSchema>();
  const phase = useWatch({
    name: 'phase',
    control: formMethods.control,
  });
  const deliverable = useWatch({
    name: 'deliverable',
    control: formMethods.control,
  });

  const { data } = useDeliverables({
    params: {
      page: 1,
      perPage: 10,
      project_id: Number(projectId),
      phase: phase?.value,
    },
  });

  const deliverables = data as IGetDeliverablesServiceRes | undefined;
  const deliverableOptions = deliverables?.data.map((deliverable) => ({
    label: deliverable.name,
    value: String(deliverable.id),
    dueDate: deliverable.dueDate,
  }));

  useUpdateEffect(() => {
    const currentDeliverable = deliverables?.data.find((option) => String(option.id) === String(deliverable?.value));

    if (currentDeliverable) {
      formMethods.setValue('proposedDueDate', formatDate3(currentDeliverable.dueDate, 'yyyy-mm-dd'));
      formMethods.setValue('dueDate', formatDate3(currentDeliverable.dueDate, 'yyyy-mm-dd'));

      const { phase } = formMethods.getValues();

      if (!phase) {
        formMethods.setValue('phase', {
          label: capitalize(currentDeliverable.phase),
          value: currentDeliverable.phase.toUpperCase(),
        });
      }
    }
  }, [deliverable]);

  return (
    <HookReactSingleSelect
      formMethods={formMethods}
      label='Deliverable'
      options={deliverableOptions}
      placeholder=''
      isDisabled={isDisabled}
      name='deliverable'
    />
  );
}
